export default () => ({
  componentName: 'cell-number',
});
